import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {path: '/', name: 'newsList', component: resolve => require(['@src/pages/newsList/newsList'], resolve), meta: {title: '新闻列表'}},
    // {path: '/detail/:id', name: 'newsDetail', component: resolve => require(['@src/pages/newsDetail/newsDetail'], resolve), meta: {title: '新闻详情'}}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js